import 'jquery';
import {sendGoToListingEvent as sendLegacy} from "./legacy-analytics.js";
import {sendGoToListingEvent as sendAnalytics4} from "./google-analytics4.js";

var snippetSelector = ".serp-snippet";

export function init() {
    function snippetClickAction(e) {
        var video = $(this).find('.video-js');
        if (!video.is(e.target) && video.has(e.target).length === 0) {
            setPreventAndPropagation(e);
            goToAdActions($(this));
        }
    }

    $(document).on('click', snippetSelector, function(e) {
        snippetClickAction.call(this, e);
    });

    var sliderAdElement = $('.slider-ad');
    sliderAdElement.each(function () {
        $(this).slick({
            lazyLoad: 'anticipated',
            arrows: false
        });
    });
    sliderAdElement.on('swipe', function (event, slick, direction) {
        changeSlide(this, 'swipe', slick.currentSlide, direction);
    });

    $('.slick-slider').on('click', '.slick-slide', function (event) {
        $(this).parents(snippetSelector).click();
    });

    var adPhotoElement = $('.ad-ph');

    $(".slider-cta").on('click', ".btn-contact", function(e) {
        setPreventAndPropagation(e);
        sendContact.call(this);
    });
    adPhotoElement.on('click', '.slider-chevron.left', function (e) {
        setPreventAndPropagation(e);
        var sliderElement = $(this).parents('.ad-ph').find(".slider-ad");
        sliderElement.slick('slickPrev');
        changeSlide(this, 'arrow', sliderElement.slick('slickCurrentSlide'), 'left');
    });

    adPhotoElement.on('click', '.slider-chevron.right', function (e) {
        setPreventAndPropagation(e);
        var sliderElement = $(this).parents('.ad-ph').find(".slider-ad");
        sliderElement.slick('slickNext');
        changeSlide(this, 'arrow', sliderElement.slick('slickCurrentSlide'), 'right');
    });

    setEventCtaButtonGoToDetail();
}

function changeSlide(obj, slideType, currentSlide, direction) {
    var photoElement = $(obj).parents('.ad-ph');
    var photoCounterElement = photoElement.find(".icon.photo");
    var totalPhotos = photoCounterElement.find('.total').html();
    var currentPhotoNumber = photoCounterElement.find('.current');
    var agencyLogo = photoElement.find(".agencyLogo");
    var adId = $(obj).parents(snippetSelector).attr("id");
    var contactButtonExist = photoElement.find('.slider-main-cta').length > 0;
    var totalPhotosPrinted = photoCounterElement.data('total');
    var isInContactSlider = currentSlide + 1 > totalPhotosPrinted;
    var eventData = $(obj).parents(snippetSelector).data('ev');


    currentPhotoNumber.html(currentSlide + 1);
    toggleAgencyLogo();
    togglePhotoCounter();
    sendEventSlidePhotos(obj, slideType, currentSlide, direction, totalPhotos, eventData);
    // TODO sólo lanzar métrica la primera vez que se visualiza el slide cta,  por anuncio
    if (isInContactSlider && contactButtonExist && !photoElement.attr("data-cta-shown")) {
        sendAdListingCarouselApplyImpressionStep1(adId);
        photoElement.attr("data-cta-shown", true);
    }

    function toggleAgencyLogo() {
        if (currentSlide === 0) {
            agencyLogo.fadeIn();
        } else {
            agencyLogo.fadeOut();
        }
    }
    function togglePhotoCounter() {
        if (isInContactSlider) {
            photoCounterElement.hide();
        } else {
            photoCounterElement.show();
        }
    }
    function sendAdListingCarouselApplyImpressionStep1(adId) {
        var parameters = "adId=" + adId + "&dcstai=ADS_LISTING_CAROUSEL";
        var pvParams = getPvParams();
        if (pvParams) {
            parameters += "&pvParams=" + pvParams;
        }
        $.ajax({
            type: "POST",
            url: "/smp",
            data: parameters,
            success: function(r) {
            }
        });
    }
}

function sendEventSlidePhotos(obj, slideType, currentSlide, direction, totalPhotos, eventData) {
    var labelTemp = analyticsObjects.labelElements.slide + "-" + direction + "-" + slideType + "-" + (currentSlide + 1) + "-" + totalPhotos;
    if (eventData.length > 0) {
        labelTemp += '-' + hex2a(eventData);
    }
    analytics.submitEventAction(awp, analyticsObjects.actions.slide, labelTemp);
}

function setEventCtaButtonGoToDetail() {
    $('.slider-cta').on('click', '.slider-secondary-cta', function (e) {
        setPreventAndPropagation(e);
        if ($(this).parents('.serp-snippet-mobile').length !== 0) {
            goToAdActions($(this).parents('.serp-snippet-mobile'), $(this).data("type"));
        } else {
            goToAdActions($(this).parents(snippetSelector), $(this).data("type"));
        }
    });
}

function goToAdActions(snippetElement, analyticsPostfix) {
    var link = snippetElement.find('.title .detail-redirection');
    if (urlRequest !== "") {
        jsUtils.setCookie("_param_url_base", urlRequest);
    }
    let snippetEncryptedData = snippetElement.data('ev');
    sendLegacy(analyticsPostfix, snippetEncryptedData);
    sendAnalytics4(snippetElement.attr('id'))

    if ($(link).hasClass("uExternalLRefresh")) {
        launchingRefresh($(link).attr("id"));
    } else if ($(link).hasClass("uExternalL")) {
        launching($(link).attr("id"));
    } else {
        document.location.href = link.attr('href');
    }
}
